import { gql } from '@apollo/client'

export const PERMISSIONS_QUERY = gql`
  query Permissions($filters: PermissionsInput!) {
    permissions(filters: $filters) {
      permissionName
      subPermissions {
        name
        actions {
          permissionID
          action
          selected
          disabled
          permissionSource
        }
      }
    }
  }
`

export const USER_PERMISSIONS_QUERY = gql`
  query UserPermissions($userID: String!) {
    userPermissions(userID: $userID) {
      permissionName
      subPermissions {
        name
        actions {
          permissionID
          action
          selected
          disabled
          permissionSource
        }
      }
    }
  }
`

export const UPDATE_USER_PERMISSIONS_MUTATION = gql`
  mutation UpdateUserPermissions($input: UpdateUserPermissionsInput!) {
    updateUserPermissions(input: $input) {
      message
    }
  }
`
